import React from "react"
import PropTypes from "prop-types"

import MeetingListItem from './MeetingListItem';

class PastMeetingsContainer extends React.Component {

  constructor(props) {
    super(props)

    this.renderMeetings = this.renderMeetings.bind(this)
  }

  renderMeetings() {
    return this.props.meetings.map((meeting, i) => {
      return(
        <MeetingListItem
          key={i}
          item={meeting}
          currentUser={this.props.currentUser}
          getAllMeetings={this.props.getAllMeetings}
          passed={true}
        />
      )
    })
  }

  render() {
    return(
      <div style={{marginTop: 50}}>
        <h5 className="sectionHeader">Past Lexes</h5>
        {this.renderMeetings()}
      </div>
    )
  }

}

export default PastMeetingsContainer;
